import React, { useContext, useEffect, useState } from "react";
import "./Your_Booking_Conditions.css";
import Prev_Btn from "../../../../common/common-btn/prev-btn/Prev_Btn";
import Next_Btn from "../../../../common/common-btn/next-btn/Next_Btn";
import { Context } from "../../../../../utils/context";
import { useForm } from "react-hook-form";
import { formatAmount } from "../../../../../utils/common";

const Your_Booking_Conditions = ({ setActiveTab, }) => {

  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    putData, appSetup,

    BookingData,
    setBookingData
  } = useContext(Context);

  const {
    register, control, reset,
    handleSubmit, watch, setValue,
    formState: { errors },
  } = useForm();
  const [selected, setSelected] = useState("");
  const handleNext = () => {
    setActiveTab("price");
  };

  const handleBack = () => {
    setActiveTab("details");
  };

  const resetFormData = async () => {
    reset({
      cylinder_status: String(BookingData?.cylinder_status),
    });
  }

  useEffect(() => {
    resetFormData()
  }, [BookingData]);


  const onSubmit = async (data) => {

    console.log("Form Data:", data);
    const formData = new FormData();

    formData.append("cylinder_status", data?.cylinder_status);

    const response = await postData(`/without-login/booking/step-1/${BookingData?.id}`, formData);
    if (response?.success) {
      // setTimeout(() => {
      handleNext()
      // }, 2500);
    } else {
      // setApiError(response?.errors)
      console.error("Form submission failed:", response?.errors);
    }
  };


  return (
    <section className="Your_Booking_Conditions">
      <div className="booking_card">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6 col-sm-6">
            <h6 className="booking_headings">Booking includes:</h6>

            <p className="booking_text">
              Car with Ladakhi driver <br /> Fuel <br /> Tolls and parking fees
            </p>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-6">
            <h6 className="booking_headings">Booking includes:</h6>

            <p className="booking_text">Meals</p>
          </div>
        </div>

        <div className="black_strip">
          The booking can be cancelled until {appSetup?.cancel_days || "10"} days before the start date and a {appSetup?.cancel_percentage || "17"}% cancellation fee will apply.
        </div>
      </div>

      <div className="booking_card">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="col_holder">
              <h6 className="booking_headings">Oxygen cylinder rental</h6>

              <p className="booking_text">
                While oxygen helps mitigate the effects of Acute Mountain
                Sickness (AMS), it is not a substitute for proper safety
                protocols. Even with a rental cylinder, adhering to standard
                acclimatization guidelines remains mandatory.
              </p>
              <p className="booking_text">
                If someone exhibits symptoms of altitude sickness, the priority
                is an immediate descent to a lower elevation. In these
                scenarios, supplemental oxygen serves as a vital support measure
                to stabilize the individual during transit.
              </p>
            </div>

            <div className="col_holder">
              <h6 className="booking_headings">Cylinder Duration & Usage</h6>

              <p className="booking_text">
                The lifespan of the oxygen supply depends on the severity of the
                symptoms & the required flow rate:
              </p>

              {/* <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <h6 className="booking_headings">Condition</h6>
                  <p className="booking_text">
                    Severe AMS <br /> Mild AMS
                  </p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <h6 className="booking_headings">Recommended Flow Rate</h6>
                  <p className="booking_text">
                    2 Liters per minute (2L/min) <br />1 Liter per minute
                    (1L/min)
                  </p>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6">
                  <h6 className="booking_headings">Estimated Duration</h6>
                  <p className="booking_text">
                    3 Hours 30 Minutes <br /> 7 Hours
                  </p>
                </div>
              </div> */}
            </div>
          </div>

          <div className="oxygen_rent_div">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h6 className="booking_headings">
                  Would you like to rent an oxygen cylinder during your trip?
                </h6>
                <div className="checkbox_container">
                  {/* Yes */}
                  <label
                    className={`option ${watch("cylinder_status") === "1" ? "active" : ""
                      }`}
                  >
                    <input
                      type="radio"   // 🔥 change to radio (only one selection)
                      value="1"
                      {...register("cylinder_status", {
                        required: "Please select an option",
                      })}
                    />
                    <span className="booking_text">
                      Yes, for a total cost of {formatAmount(appSetup?.cylinder_price_per_day || 500)} per Day
                    </span>
                  </label>

                  {/* No */}
                  <label
                    className={`option ${watch("cylinder_status") === "0" ? "active" : ""
                      }`}
                  >
                    <input
                      type="radio"
                      value="0"
                      {...register("cylinder_status")}
                    />
                    <span className="booking_text">No, Thanks!</span>
                  </label>
                </div>

                {errors?.cylinder_status && (
                  <span className="text-danger">{errors.cylinder_status.message}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="both_btn_holder">
        <div onClick={handleBack}>
          <Prev_Btn text="Back" />
        </div>

        <div onClick={handleSubmit(onSubmit)}>
          <Next_Btn text="Next" />
        </div>
      </div>
    </section>
  );
};

export default Your_Booking_Conditions;
